import { termsAndConditions } from "../../constants/termsAndConditions";
import styles from "./TermsModal.module.css";

const TermsModal = ({ language, onClose }) => {
  const content = termsAndConditions[language] ?? termsAndConditions.en;

  return (
    <div
      className={styles.overlay}
      onClick={onClose}
      role="presentation"
    >
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-modal-title"
      >
        <div className={styles.header}>
          <h3 id="terms-modal-title" className={styles.title}>
            {content.title}
          </h3>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className={styles.body}>
          <p className={styles.intro}>{content.intro}</p>
          {content.sections.map((section) => (
            <section key={section.title} className={styles.section}>
              <h4 className={styles.sectionTitle}>{section.title}</h4>
              <p className={styles.sectionBody}>{section.body}</p>
            </section>
          ))}
          <p className={styles.footerMeta}>{content.lastUpdated}</p>
          <p className={styles.footerMeta}>{content.copyright}</p>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
